import { Skills } from '../types'

const SKILLS: Skills = {
  fitness: {
    key: 'fitness',
    name: 'Fitness',
    type: 'base',
    abbreviation: 'FIT',
    description:
      'Higher levels increase Energy recovery rate and Max Energy. During surfing, increases wave catch probability and decreases wave waiting time.',
    order: 1,
    levels: {
      fitness0: { name: 'Out of breath after paddling out', key: 'fitness0', points: 0 },
      fitness1: { name: 'Manage 1-2 waves before exhaustion', key: 'fitness1', points: 100.0 },
      fitness2: { name: 'More energy, surf 3-4 waves', key: 'fitness2', points: 1000.0 },
      fitness3: { name: 'Regular surfing sessions possible', key: 'fitness3', points: 20000.0 },
      fitness4: { name: 'Multiple hours of surfing per day', key: 'fitness4', points: 330000.0 },
      fitness5: { name: "Endless energy—you're a fitness machine!", key: 'fitness5', points: 4200000.0 }
    }
  },
  paddling: {
    key: 'paddling',
    name: 'Paddling',
    description:
      'How fast you can get out to the lineup and paddle in to waves. Higher levels increase wave catch probability and decrease wave waiting time.',
    order: 2,
    type: 'base',
    abbreviation: 'PAD',
    levels: {
      paddling0: { name: 'Can barely paddle out past the whitewater', key: 'paddling0', points: 0 },
      paddling1: { name: 'Paddling improves, but still struggle in currents', key: 'paddling1', points: 100.0 },
      paddling2: { name: 'Easier time paddling out, avoid some wipeouts', key: 'paddling2', points: 1000.0 },
      paddling3: { name: 'Quickly reach the lineup', key: 'paddling3', points: 20000.0 },
      paddling4: { name: 'Smooth paddling in almost any condition', key: 'paddling4', points: 330000.0 },
      paddling5: { name: 'You can paddle out in huge swells with ease', key: 'paddling5', points: 4200000.0 }
    }
  },
  popup: {
    key: 'popup',
    name: 'Popup',
    description: 'How fast and consistently can you pop up. Higher levels increase wave catch probability',
    order: 3,
    type: 'base',
    abbreviation: 'POP',
    levels: {
      popup0: { name: 'Struggling to get up', key: 'popup0', points: 0 },
      popup1: { name: 'Can get up on small waves, but slow', key: 'popup1', points: 100.0 },
      popup2: { name: 'Faster popup, but still awkward', key: 'popup2', points: 1000.0 },
      popup3: { name: 'Reliable popup on most waves', key: 'popup3', points: 20000.0 },
      popup4: { name: 'Quick and balanced popup', key: 'popup4', points: 330000.0 },
      popup5: { name: 'Perfect timing, never miss a popup', key: 'popup5', points: 4200000.0 }
    }
  },
  whitewater_riding: {
    key: 'whitewater_riding',
    name: 'Whitewater Riding',
    description: 'Mastery of small, broken waves.',
    order: 4,
    type: 'white',
    abbreviation: 'WWR',
    levels: {
      whitewater_riding0: { name: 'Constant wipeouts', key: 'whitewater_riding0', points: 0 },
      whitewater_riding1: { name: 'Can stand up in whitewater but unsteady', key: 'whitewater_riding1', points: 100.0 },
      whitewater_riding2: { name: 'Ride whitewater consistently', key: 'whitewater_riding2', points: 1000.0 },
      whitewater_riding3: { name: 'Turn on whitewater', key: 'whitewater_riding3', points: 20000.0 },
      whitewater_riding4: { name: 'Controlled rides with small turns', key: 'whitewater_riding4', points: 330000.0 },
      whitewater_riding5: {
        name: 'Seamlessly transition from whitewater to green waves',
        key: 'whitewater_riding5',
        points: 4200000.0
      }
    }
  },
  green_wave_riding: {
    key: 'green_wave_riding',
    name: 'Green Wave Riding',
    description: 'Surfing on the unbroken face of a wave.',
    order: 5,
    type: 'maneuver',
    abbreviation: 'GWR',
    levels: {
      green_wave_riding0: { name: "Can't catch green waves", key: 'green_wave_riding0', points: 0 },
      green_wave_riding1: { name: 'Catch small green waves occasionally', key: 'green_wave_riding1', points: 100.0 },
      green_wave_riding2: { name: 'Ride small green waves confidently', key: 'green_wave_riding2', points: 1000.0 },
      green_wave_riding3: { name: 'Consistently ride green waves', key: 'green_wave_riding3', points: 20000.0 },
      green_wave_riding4: { name: 'Handle larger, faster green waves', key: 'green_wave_riding4', points: 330000.0 },
      green_wave_riding5: {
        name: 'Surf big, perfect waves like a pro',
        key: 'green_wave_riding5',
        points: 4200000.0
      }
    }
  },
  forecasting_and_observing: {
    key: 'forecasting_and_observing',
    name: 'Forecasting and Observing',
    description:
      'Ability to read the ocean and predict good surf conditions. Higher levels decrease wave waiting time.',
    order: 6,
    type: 'knowledge',
    abbreviation: 'FOB',
    levels: {
      forecasting_and_observing0: {
        name: 'No clue about wave conditions',
        key: 'forecasting_and_observing0',
        points: 0
      },
      forecasting_and_observing1: {
        name: 'Can tell when waves are too small to surf',
        key: 'forecasting_and_observing1',
        points: 100.0
      },
      forecasting_and_observing2: {
        name: 'Know when conditions are decent',
        key: 'forecasting_and_observing2',
        points: 1000.0
      },
      forecasting_and_observing3: {
        name: 'Predict good surf days with some accuracy',
        key: 'forecasting_and_observing3',
        points: 20000.0
      },
      forecasting_and_observing4: {
        name: 'Read weather and tides to forecast great conditions',
        key: 'forecasting_and_observing4',
        points: 330000.0
      },
      forecasting_and_observing5: {
        name: 'Ocean guru—forecast perfect surf with pinpoint accuracy',
        key: 'forecasting_and_observing5',
        points: 4200000.0
      }
    }
  },
  wave_reading: {
    key: 'wave_reading',
    name: 'Wave Reading',
    description: 'How well you can judge which waves to take and avoid. Higher levels increase wave catch probability.',
    order: 7,
    type: 'knowledge',
    abbreviation: 'WRD',
    levels: {
      wave_reading0: { name: 'Take every wave, good or bad', key: 'wave_reading0', points: 0 },
      wave_reading1: { name: 'Can occasionally spot a decent wave', key: 'wave_reading1', points: 100.0 },
      wave_reading2: { name: 'Pick out some rideable waves', key: 'wave_reading2', points: 1000.0 },
      wave_reading3: { name: 'Avoid bad waves, catch better ones', key: 'wave_reading3', points: 20000.0 },
      wave_reading4: {
        name: 'Consistently catch the best waves in the set',
        key: 'wave_reading4',
        points: 330000.0
      },
      wave_reading5: {
        name: 'Instinctively know which wave will be perfect',
        key: 'wave_reading5',
        points: 4200000.0
      }
    }
  },
  bottom_turn_front: {
    key: 'bottom_turn_front',
    name: 'Bottom Turn (Frontside)',
    description: 'A frontside turn at the base of the wave to generate speed and set up maneuvers.',
    order: 8,
    type: 'maneuver',
    abbreviation: 'BTF',
    levels: {
      bottom_turn_front0: { name: "Can't perform a proper bottom turn", key: 'bottom_turn_front0', points: 0 },
      bottom_turn_front1: {
        name: 'Basic frontside bottom turns, occasionally slow',
        key: 'bottom_turn_front1',
        points: 100.0
      },
      bottom_turn_front2: {
        name: 'Smooth frontside bottom turns, maintaining momentum',
        key: 'bottom_turn_front2',
        points: 1000.0
      },
      bottom_turn_front3: {
        name: 'Carve into your frontside bottom turns, setting up bigger moves',
        key: 'bottom_turn_front3',
        points: 20000.0
      },
      bottom_turn_front4: {
        name: 'Powerful frontside bottom turns, maintaining speed through larger waves',
        key: 'bottom_turn_front4',
        points: 330000.0
      },
      bottom_turn_front5: {
        name: 'Mastery of frontside bottom turns, carving deep and fast under any condition',
        key: 'bottom_turn_front5',
        points: 4200000.0
      }
    }
  },
  bottom_turn_back: {
    key: 'bottom_turn_back',
    name: 'Bottom Turn (Backside)',
    description: "A backside turn to set up for waves, trickier because you're facing away from the wave.",
    order: 9,
    type: 'maneuver',
    abbreviation: 'BTB',
    levels: {
      bottom_turn_back0: { name: "Can't hold balance on a backside turn", key: 'bottom_turn_back0', points: 0 },
      bottom_turn_back1: {
        name: 'Awkward but functional backside bottom turns',
        key: 'bottom_turn_back1',
        points: 100.0
      },
      bottom_turn_back2: {
        name: 'Clean backside bottom turns with moderate speed',
        key: 'bottom_turn_back2',
        points: 1000.0
      },
      bottom_turn_back3: {
        name: 'Carve backside bottom turns, generating more speed for bigger moves',
        key: 'bottom_turn_back3',
        points: 20000.0
      },
      bottom_turn_back4: {
        name: 'Confident backside bottom turns on steeper waves',
        key: 'bottom_turn_back4',
        points: 330000.0
      },
      bottom_turn_back5: {
        name: 'Perfect backside bottom turns, carving with precision in challenging conditions',
        key: 'bottom_turn_back5',
        points: 4200000.0
      }
    }
  },
  cutback_front: {
    key: 'cutback_front',
    name: 'Cutback (Frontside)',
    description: 'A frontside turn redirecting back toward the wave.',
    order: 11,
    type: 'maneuver',
    abbreviation: 'CTF',
    levels: {
      cutback_front0: { name: 'Struggle to perform a cutback', key: 'cutback_front0', points: 0 },
      cutback_front1: { name: 'Basic frontside cutbacks, but often lose speed', key: 'cutback_front1', points: 100.0 },
      cutback_front2: { name: 'Clean cutbacks, maintaining momentum', key: 'cutback_front2', points: 1000.0 },
      cutback_front3: {
        name: 'Roundhouse Cutback: Larger, sweeping cutbacks for more power',
        key: 'cutback_front3',
        points: 20000.0
      },
      cutback_front4: {
        name: 'Tight and controlled cutbacks on big waves',
        key: 'cutback_front4',
        points: 330000.0
      },
      cutback_front5: {
        name: 'Perfect frontside cutbacks, seamlessly integrated into all rides',
        key: 'cutback_front5',
        points: 4200000.0
      }
    }
  },
  cutback_back: {
    key: 'cutback_back',
    name: 'Cutback (Backside)',
    description: 'A backside turn redirecting toward the wave.',
    order: 12,
    type: 'maneuver',
    abbreviation: 'CTB',
    levels: {
      cutback_back0: { name: "Can't complete a proper backside cutback", key: 'cutback_back0', points: 0 },
      cutback_back1: { name: 'Basic backside cutbacks with limited control', key: 'cutback_back1', points: 100.0 },
      cutback_back2: { name: 'Reliable backside cutbacks on smaller waves', key: 'cutback_back2', points: 1000.0 },
      cutback_back3: {
        name: 'Roundhouse Cutback: Larger backside cutbacks with full power',
        key: 'cutback_back3',
        points: 20000.0
      },
      cutback_back4: {
        name: 'Confident backside cutbacks on steeper, bigger waves',
        key: 'cutback_back4',
        points: 330000.0
      },
      cutback_back5: {
        name: 'Perfect backside cutbacks on any wave, keeping style and control',
        key: 'cutback_back5',
        points: 4200000.0
      }
    }
  },
  speed_generation: {
    key: 'speed_generation',
    name: 'Speed Generation',
    description: 'Generating speed from turns and pumping the board.',
    order: 10,
    type: 'maneuver',
    abbreviation: 'SPG',
    levels: {
      speed_generation0: { name: "Can't generate speed, constantly bogged down", key: 'speed_generation0', points: 0 },
      speed_generation1: { name: 'Some basic speed generation', key: 'speed_generation1', points: 100.0 },
      speed_generation2: {
        name: 'Pump and turn to pick up speed on small waves',
        key: 'speed_generation2',
        points: 1000.0
      },
      speed_generation3: { name: 'Generate speed on most turns', key: 'speed_generation3', points: 20000.0 },
      speed_generation4: {
        name: 'Build speed on big waves through aggressive turns',
        key: 'speed_generation4',
        points: 330000.0
      },
      speed_generation5: {
        name: 'Max speed generation on any wave, even in weak conditions',
        key: 'speed_generation5',
        points: 4200000.0
      }
    }
  },
  top_turn_front: {
    key: 'top_turn_front',
    name: 'Top Turn (Frontside)',
    description: 'A frontside turn at the top of the wave.',
    order: 14,
    type: 'maneuver',
    abbreviation: 'TTF',
    levels: {
      top_turn_front0: { name: 'Hesitant top turns, losing speed', key: 'top_turn_front0', points: 0 },
      top_turn_front1: {
        name: 'Basic frontside top turns, maintaining some momentum',
        key: 'top_turn_front1',
        points: 100.0
      },
      top_turn_front2: { name: 'Add a Snap to your top turns for more flair', key: 'top_turn_front2', points: 1000.0 },
      top_turn_front3: { name: 'Consistent top turns on most waves', key: 'top_turn_front3', points: 20000.0 },
      top_turn_front4: {
        name: 'Off-the-Lip: Powerfully redirect at the lip of the wave',
        key: 'top_turn_front4',
        points: 330000.0
      },
      top_turn_front5: {
        name: 'Seamless frontside top turns, generating power and throwing spray on every wave',
        key: 'top_turn_front5',
        points: 4200000.0
      },
      top_turn_front6: {
        name: "GOAT Status: Your frontside top turns redefine what's physically possible on a wave",
        key: 'top_turn_front6',
        points: 15000000.0
      }
    }
  },
  top_turn_back: {
    key: 'top_turn_back',
    name: 'Top Turn (Backside)',
    description: 'A backside turn at the top of the wave.',
    order: 15,
    type: 'maneuver',
    abbreviation: 'TTB',
    levels: {
      top_turn_back0: { name: 'Struggle to make proper backside top turns', key: 'top_turn_back0', points: 0 },
      top_turn_back1: {
        name: 'Manage basic backside top turns, but inconsistent',
        key: 'top_turn_back1',
        points: 100.0
      },
      top_turn_back2: {
        name: 'Add a Snap to your backside turns, maintaining speed',
        key: 'top_turn_back2',
        points: 1000.0
      },
      top_turn_back3: {
        name: 'Clean, consistent backside top turns on most waves',
        key: 'top_turn_back3',
        points: 20000.0
      },
      top_turn_back4: {
        name: 'Off-the-Lip: Aggressive turns off the lip with full control',
        key: 'top_turn_back4',
        points: 330000.0
      },
      top_turn_back5: {
        name: 'Perfect backside top turns, launching spray with power on all waves',
        key: 'top_turn_back5',
        points: 4200000.0
      },
      top_turn_back6: {
        name: 'GOAT Status: Your backside top turns make physics professors question reality',
        key: 'top_turn_back6',
        points: 15000000.0
      }
    }
  },
  speed_control: {
    key: 'speed_control',
    name: 'Speed Control',
    description: 'Balancing speed during the ride.',
    order: 13,
    type: 'maneuver',
    abbreviation: 'SPC',
    levels: {
      speed_control0: { name: 'No speed control—often too slow or too fast', key: 'speed_control0', points: 0 },
      speed_control1: { name: 'Occasionally manage wave speed', key: 'speed_control1', points: 100.0 },
      speed_control2: { name: 'Can control speed on smaller waves', key: 'speed_control2', points: 1000.0 },
      speed_control3: { name: 'Keep perfect speed on most waves', key: 'speed_control3', points: 20000.0 },
      speed_control4: {
        name: 'Make adjustments mid-ride to maintain speed',
        key: 'speed_control4',
        points: 330000.0
      },
      speed_control5: {
        name: 'Master speed control, never losing momentum',
        key: 'speed_control5',
        points: 4200000.0
      }
    }
  },
  floater: {
    key: 'floater',
    name: 'Floater',
    description: "Riding along the top of the wave's foam, maintaining balance and speed.",
    order: 16,
    type: 'maneuver',
    abbreviation: 'FLT',
    levels: {
      floater0: { name: "Can't balance on a floater, constantly falling off", key: 'floater0', points: 0 },
      floater1: { name: 'Manage small floaters, but struggle with control', key: 'floater1', points: 100.0 },
      floater2: { name: 'Consistently perform floaters on smaller waves', key: 'floater2', points: 1000.0 },
      floater3: { name: 'Hold longer floaters with clean transitions', key: 'floater3', points: 20000.0 },
      floater4: { name: 'Perform floaters on steeper, faster waves', key: 'floater4', points: 330000.0 },
      floater5: {
        name: "Master floaters, seamlessly balancing on top of any wave's foam",
        key: 'floater5',
        points: 4200000.0
      }
    }
  },
  aerial: {
    key: 'aerial',
    name: 'Aerial',
    description: 'Launching off the wave into the air.',
    order: 17,
    type: 'maneuver',
    abbreviation: 'AIR',
    levels: {
      aerial0: { name: "Can't catch air, wipeout every time", key: 'aerial0', points: 0 },
      aerial1: { name: 'Barely launch but fail to land', key: 'aerial1', points: 100.0 },
      aerial2: { name: 'Land small aerials with some control', key: 'aerial2', points: 10000.0 },
      aerial3: { name: 'Pull off full Frontside 360 aerials', key: 'aerial3', points: 200000.0 },
      aerial4: { name: 'Cleanly land bigger airs, add style like Backside 360s', key: 'aerial4', points: 1000000.0 },
      aerial5: {
        name: 'Perfect huge aerials, integrating 360s and Reverse 360s with full control',
        key: 'aerial5',
        points: 4200000.0
      },
      aerial6: {
        name: 'Legendary Status: Your aerials defy gravity—people travel worldwide just to witness them',
        key: 'aerial6',
        points: 15000000.0
      }
    }
  },
  air_reverse: {
    key: 'air_reverse',
    name: 'Air Reverse',
    description: 'Performing an aerial and spinning 180 degrees.',
    order: 18,
    type: 'maneuver',
    abbreviation: 'ARR',
    levels: {
      air_reverse0: { name: "Can't rotate mid-air, constant wipeouts", key: 'air_reverse0', points: 0 },
      air_reverse1: { name: 'Start rotating mid-air but fail to land', key: 'air_reverse1', points: 100.0 },
      air_reverse2: { name: 'Occasionally land the air reverse, but lose speed', key: 'air_reverse2', points: 10000.0 },
      air_reverse3: {
        name: 'Consistently land air reverses with smooth transitions',
        key: 'air_reverse3',
        points: 200000.0
      },
      air_reverse4: {
        name: 'Land air reverses with added Frontside/Backside 360 spins',
        key: 'air_reverse4',
        points: 1000000.0
      },
      air_reverse5: {
        name: 'Seamlessly integrate Air Reverse and 360s into any aerial, landing with style',
        key: 'air_reverse5',
        points: 4200000.0
      },
      air_reverse6: {
        name: 'GOAT Level: Your air reverses are studied by physicists and copied by every pro',
        key: 'air_reverse6',
        points: 15000000.0
      }
    }
  },
  barrel: {
    key: 'barrel',
    name: 'Barrel Riding',
    description: 'Riding inside the hollow tube of the wave.',
    order: 19,
    type: 'maneuver',
    abbreviation: 'BAR',
    levels: {
      barrel0: { name: "Can't even enter the barrel, constantly falling behind", key: 'barrel0', points: 0 },
      barrel1: { name: 'Enter the barrel but get closed out almost immediately', key: 'barrel1', points: 100.0 },
      barrel2: { name: 'Ride small barrels briefly, but often lose control', key: 'barrel2', points: 10000.0 },
      barrel3: {
        name: 'Stay inside the barrel for longer, holding balance and speed',
        key: 'barrel3',
        points: 200000.0
      },
      barrel4: { name: 'Ride deep into bigger barrels without losing control', key: 'barrel4', points: 1000000.0 },
      barrel5: {
        name: 'Perfect barrel rides, staying deep and stylish in any conditions',
        key: 'barrel5',
        points: 4200000.0
      },
      barrel6: {
        name: "Mythical Status: You can disappear into barrels so long people think you've drowned—then emerge victorious",
        key: 'barrel6',
        points: 15000000.0
      }
    }
  }
}

export default SKILLS
